<script lang="ts" setup>
import { computed } from "vue";
import { isNullish, ProfilePictureSize, TuProfilePicture } from "@tinyurldev/tu-ui-vue";

import NameToInitials from "@Resources/js/filters/NameToInitials";

interface User {
  name?: string;
  photo_url?: string | null;
}

interface Props {
  user?: User | null;
  size?: ProfilePictureSize;
}

//
// Props
const props = withDefaults(defineProps<Props>(), {
  user: null,
  size: ProfilePictureSize.SMALL,
});

//
// Computed
const photo = computed(() => {
  const url = props.user?.photo_url;

  if (isNullish(url) || url.endsWith("/images/user.svg")) {
    return;
  };

  return url;
});

const name = computed<string>(() => props.user?.name || "");

const backgroundColor = computed<string>(() => {
  if (isNullish(name.value)) return "#6b7280";

  let hash = 0;
  for (let i = 0; i < name.value.length; i++) {
    hash = name.value.charCodeAt(i) + ((hash << 5) - hash);
  }

  const colors = [
    "#ef4444", // red
    "#f97316", // orange
    "#f59e0b", // amber
    "#84cc16", // lime
    "#22c55e", // green
    "#14b8a6", // teal
    "#06b6d4", // cyan
    "#0ea5e9", // sky
    "#3b82f6", // blue
    "#6366f1", // indigo
    "#8b5cf6", // violet
    "#a855f7", // purple
    "#d946ef", // fuchsia
    "#ec4899", // pink
  ];

  return colors[Math.abs(hash) % colors.length] ?? "#6b7280";
});
</script>

<template>
  <TuProfilePicture
    :excerpt="NameToInitials(name)"
    :src="photo"
    :size="size"
    :color="backgroundColor"
  />
</template>
